import "core-js/modules/es.array.push.js";
import { customerResource } from '../../system/customerManage/request';
import { messageLogList, pushScenarioResource, cancelMessgaeSend } from './request';
export default {
  data() {
    return {
      form: {
        eventId: '',
        customerId: undefined,
        messageCategory: undefined,
        pushScenario: undefined,
        processingStatus: undefined
      },
      customersList: [],
      structureList: [],
      structureListTree: [],
      pushScenarioList: [],
      dataSource: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        dataIndex: 'index',
        slots: {
          title: '序号'
        },
        align: 'center'
      }, {
        dataIndex: 'eventId',
        slots: {
          title: '事件ID'
        },
        align: 'center'
      }, {
        dataIndex: 'customerName',
        slots: {
          title: '客户名称'
        },
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        dataIndex: 'messageCategoryName',
        slots: {
          title: '消息类别'
        },
        align: 'center',
        customRender: (text, record) => {
          return this.$t(text) || '-';
        }
      }, {
        dataIndex: 'pushScenarioName',
        slots: {
          title: '推送场景'
        },
        align: 'center',
        customRender: (text, record) => {
          return this.$t(text) || '-';
        }
      }, {
        dataIndex: 'processingStatusName',
        slots: {
          title: '处理状态'
        },
        align: 'center',
        customRender: (text, record) => {
          return this.$t(text) || '-';
        }
      }, {
        dataIndex: 'createAt',
        slots: {
          title: '创建时间'
        },
        align: 'center'
      }, {
        dataIndex: 'updateAt',
        slots: {
          title: '处理时间'
        },
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        dataIndex: 'action',
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }]
    };
  },
  computed: {
    pushScenarioPlaceholder() {
      return this.form.messageCategory ? `${this.$t('请选择') + this.$t('推送场景')}` : `${this.$t('请先选择消息类别')}`;
    }
  },
  created() {
    customerResource().then(res => {
      this.customersList = res;
    });
    this.getList();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getList();
    },
    reset() {
      this.form.customerId = undefined;
      this.form.messageCategory = undefined;
      this.form.pushScenario = undefined;
      this.form.eventId = '';
      this.form.processingStatus = undefined;
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      var _this$form$eventId;
      let params = {
        customerId: this.form.customerId || '',
        eventId: ((_this$form$eventId = this.form.eventId) === null || _this$form$eventId === void 0 ? void 0 : _this$form$eventId.trim()) || '',
        messageCategory: this.form.messageCategory || '',
        pushScenario: this.form.pushScenario || '',
        processingStatus: this.form.processingStatus || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      messageLogList(params).then(res => {
        this.dataSource = res.items;
        this.pagination.total = Number(res.totalNum);
      });
    },
    flowTypeIdChange(value) {
      this.form.pushScenario = undefined;
      this.pushScenarioList = [];
      if (value) {
        pushScenarioResource({
          messageCategory: value
        }).then(res => {
          this.pushScenarioList = res;
        });
      }
    },
    newSystemMessage() {
      this.$router.push({
        name: 'newSystemMessage'
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getList();
    },
    seeDetail(record) {
      this.$router.push({
        name: 'systemMessageDetail',
        params: {
          id: record.id
        }
      });
    },
    cancelHandler(record) {
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('点击确认取消发送该条消息？'),
        okText: this.$t('确定'),
        onOk: () => {
          let params = {
            messageEventId: record.id,
            processingStatus: 'CANCEL'
          };
          cancelMessgaeSend(params).then(res => {
            if (res) {} else {
              this.$message.error(this.$t('操作失败，该数据状态已变更'));
            }
          }).finally(() => {
            // this.$message.error(this.$t('操作失败，该数据状态已变更'));
            this.getList();
          });
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};